export const COLLECTIONS = {
  RESOURCES: 'businesses/{businessId}/resources',
}
